import addRowResponse from "./addRowResponse";
import { isItemSortKeyEqual } from "./helpers/isSortKeyEqual";
import { isDraftsMeaningfulSaveTimeEnabled } from "owa-mail-triage-common";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import { addMailListLog, getMailListLogObjectToAddToStore } from "owa-mail-list-logging";
import type TableView from "owa-mail-list-store/lib/store/schema/TableView";
import mailStore from "owa-mail-store/lib/store/Store";
import type { ItemRow } from "owa-graph-schema";
import { type TableQueryType } from "owa-mail-list-store";

export default function appendItemWithSeekToConditionResponse(tableView: TableView, itemsToAppend: ItemRow[], itemsInView: number, hasNextPage?: boolean): void {
    // Server did not return anything
    if (!itemsToAppend || itemsToAppend.length == 0) {
        return;
    }
    
    // The first item would be the last item from the previous FindItem response.
    // We check if we have that item and do a sort key comparision
    const itemIdUsedForSeekConditionRequest = itemsToAppend[0].ItemId.Id;
    
    if (!mailStore().items.has(itemIdUsedForSeekConditionRequest) ||
        (tableView.tableQuery.type != 1 && // For find item search, we do not set the sortBy property in tableQuery
            !isItemSortKeyEqual(tableView.tableQuery, 
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (30,17): Argument of type 'ClientItem | undefined' is not assignable to parameter of type 'Item'.
            // @ts-expect-error
            mailStore().items.get(itemIdUsedForSeekConditionRequest), itemsToAppend[0], isDraftsMeaningfulSaveTimeEnabled(getMailboxInfo(tableView))))) {
        // Do not process the response if the last item which was used as an instance key
        // to get the next 'n' items has
        // 1) moved in place in the table
        // Because at this point the state on the server might have changed a lot e.g. new rows might have got
        // added after this item in question and we would end up appending the new rows after the existing rows if we
        // proceed and hence we discard.
        // 2) Or the row has been deleted on client in which case we do not have anythign to compare to.
        // In both above cases we would rely on the row notifications/ or user scrolling to get more items.
        addMailListLog(getMailListLogObjectToAddToStore("AppendItemWithSeekToCondition:Aborted", {
            tableViewId: tableView.id,
            referenceItemId: itemIdUsedForSeekConditionRequest,
            missing: !mailStore().items.has(itemIdUsedForSeekConditionRequest),
        }));
        return;
    }
    
    addRowResponse(tableView, itemsToAppend, itemsInView, "AppendOnLoadMore", undefined /* searchResponseId */, undefined /* searchLogicalId */, undefined /* doNotOverwriteData */, "NextPage", hasNextPage, true /* shouldHonorTombstonedReadStateOnStitch */);
}
